import {
    Box,
    Dialog,
    Slide,
    Divider,
} from "@mui/material";
import { useState, forwardRef } from "react";
import { Swiper, SwiperSlide, FreeMode } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper';
import "swiper/swiper-bundle.css";

SwiperCore.use([Pagination])

function RefundBonus() {

    return (
        <Box>
            <Swiper
                grabCursor={true}
                slidesPerView={1}
                pagination={{ clickable: true }}
                style={{
                    width: '100%',
                    height: '100%',
                    zIndex: 1,
                    // overflow: 'scroll',
                }}
            >
                <SwiperSlide>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            marginTop: '20px'
                        }}>
                        <Box
                            sx={{
                                width: '70%',
                                fontSize: '16px',
                                marginBottom: '20px',
                                fontWeight: 'bold',
                            }}>
                            보너스쿠폰이란?
                        </Box>
                        <Box
                            sx={{
                                fontSize: '14px',
                                width: '70%',
                            }}>
                            <Box>
                                보너스쿠폰은 기간이 얼마 남지 않은 클래스쿠폰을 기간연장된 보너스쿠폰으로 변환하여 사용할 수 있는 제도입니다.
                            </Box>
                            <br></br>
                            <Box>
                                새로운 클래스쿠폰 결제시 기존 클래스쿠폰을 보너스쿠폰으로 변경할 수 있습니다.
                            </Box>
                            <Box>
                                변경된 보너스쿠폰은 새로 결제한 클래스쿠폰과 동일한 기간을 가지게 됩니다.
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '70%',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                marginTop: '20px',
                            }}>
                            예시
                        </Box>
                        <Box
                            sx={{
                                fontSize: '14px',
                                width: '70%',
                            }}>
                            <Box>
                                클래스8회권을 구매하면서 남아있는 클래스쿠폰 3장을 보너스쿠폰으로 변경할 경우
                            </Box>
                            <Box>
                                <span style={{fontWeight: 'bold'}}>유효기간이 30일인 클래스쿠폰 8장</span>과
                            </Box>
                            <Box>
                                <span style={{fontWeight: 'bold'}}>유효기간이 30일인 보너스쿠폰 3장</span>이 생성되며
                            </Box>
                            <Box>
                                총 사용가능한 쿠폰은 <span style={{fontWeight: 'bold'}}>11장</span>이 된다.
                            </Box>
                        </Box>
                    </Box>
                </SwiperSlide>
                <SwiperSlide>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            marginTop: '20px'
                        }}>
                        <Box
                            sx={{
                                width: '70%',
                                fontSize: '14px',
                                marginBottom: '20px',
                            }}>
                            클래스쿠폰을 보너스쿠폰으로 변경하기 위해 새로운 클래스쿠폰을 구매해야합니다.
                            <br></br>
                            하단메뉴에서 쿠폰구매를 클릭합니다.
                        </Box>
                        <img src='/img/bonus_help01.png' width='70%' />
                    </Box>
                </SwiperSlide>
                <SwiperSlide>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            marginTop: '20px'
                        }}>
                        <Box
                            sx={{
                                width: '70%',
                                fontSize: '14px',
                                marginBottom: '20px',
                            }}>
                            클래스쿠폰을 선택합니다.
                        </Box>
                        <img src='/img/bonus_help02.png' width='70%' />
                    </Box>
                </SwiperSlide>
                <SwiperSlide>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            marginTop: '20px'
                        }}>
                        <Box
                            sx={{
                                width: '70%',
                                fontSize: '14px',
                                marginBottom: '20px',
                            }}>
                            결제화면에서 보너스쿠폰 신청란의 신청하기를 누르고 결제를 합니다.
                        </Box>
                        <img src='/img/bonus_help03.png' width='70%' />
                    </Box>
                </SwiperSlide>
                <SwiperSlide>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            marginTop: '20px'
                        }}>
                        <Box
                            sx={{
                                width: '70%',
                                fontSize: '14px',
                                marginBottom: '20px',
                            }}>
                            결제후 하단 내수업 메뉴로 들어가 내쿠폰 탭의 클래스쿠폰을 확인하면,
                            결제한 클래스쿠폰과 기간이 동일한 보너스쿠폰이 생성되어 있는 것을 확인할 수 있습니다.
                        </Box>
                        <img src='/img/bonus_help04.png' width='70%' />
                    </Box>
                </SwiperSlide>
            </Swiper>
        </Box>
    )
}

export default RefundBonus;